import React, { Component } from "react"
import { graphql } from "gatsby"
import DefaultLayout from "../components/template/default-layout"
import PostList from "../components/post-list"
import { Helmet } from "react-helmet"

class Home extends Component {
  render() {
    const data = this.props.data
    return (
      <DefaultLayout>
        <Helmet>
          <title>
            Online Cake Classes – All about Cake, Cake Decoration, Ideas, Cake
            Design
          </title>
          <meta
            name="description"
            content="Discover cake ideas, cake decoration tips and tricks, Cake Projects"
          ></meta>
          <meta property="og:locale" content="en_US" />
          <meta property="og:type" content="website" />
          <meta
            property="og:title"
            content="V&#039;s Cake Cake Ideas Custom Cakes Special Cakes Birthday Cakes"
          />
          <meta
            property="og:description"
            content="See cake ideas, cake decoration tips and tricks, Cake Projects"
          />
          <meta
            property="og:url"
            content="http://local-onlinecakeclasses.com/"
          />
          <meta property="og:site_name" content="Online Cake Classes" />
          <meta name="twitter:card" content="summary" />
          <meta
            name="twitter:description"
            content="See cake ideas, cake decoration tips and tricks, Cake Projects"
          />
          <meta
            name="twitter:title"
            content="V&#039;s Cake Cake Ideas Custom Cakes Special Cakes Birthday Cakes"
          />
          <meta name="twitter:domain" content="Online Cake Classes" />
        </Helmet>
        <div className="banner">
          <h1>Favorite Recipes</h1>
        </div>
        <PostList data={data} category="recipes" />
      </DefaultLayout>
    )
  }
}

export default Home

export let pageQuery = graphql`
  query {
    allWordpressPage {
      edges {
        node {
          id
          title
          excerpt
          slug
          date(formatString: "MMMM DD, YYYY")
        }
      }
    }
    allWordpressPost(
      sort: { order: DESC, fields: [date] }
      filter: {
        categories: {
          elemMatch: { slug: { in: ["special-cake", "cake-bites"] } }
        }
      }
    ) {
      edges {
        node {
          slug
          title
          featured_media {
            media_details {
              file
            }
          }
          excerpt
          date
          categories {
            id
          }
        }
      }
    }
    allWordpressCategory(sort: { fields: name, order: ASC }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
